import debug from "debug";
const log = debug("ajax-loader");

function init(element) {
	log("init", element);

	const options = {
		targetElement: element,
		rootPathname: element.dataset.ajaxLoaderRootPathname,
		indicatorSelector: element.dataset.ajaxLoaderIndicatorSelector,
		fetchLinksParentSelector:
			element.dataset.ajaxLoaderFetchLinksParentSelector,
		indicatorTemplateId: element.dataset.ajaxLoaderIndicatorTemplateId,
	};

	const handlers = {
		fetchHandler: fetchPage.bind(null, options),
		// fetchPartialHandler : fetchPartial.bind(null, options),
		isInSameLongContent: isInPath.bind(null, options.rootPathname),
		getLinkToFetch: getLinkToFetch.bind(null, options),
	};

	const state = {
		href: window.location.href,
		submitting: false
	};

	window.addEventListener(
		"click",
		delegatedClickHandler.bind(null, { options, handlers, state })
	);
	window.onpopstate = historyHandler.bind(null, { options, handlers, state });

	window.addEventListener(
		"submit",
		delegatedSubmitHandler.bind(null, {state})
	);
}

function getTemplate(templateId) {
	return document.getElementById(templateId);
}

function getLinkToFetch({ fetchLinksParentSelector, rootPathname }, target) {
	const anchor = getTargetAnchor(target);

	if (
		anchor &&
		isInPath(anchor.href, rootPathname) &&
		isContainedBy(anchor, fetchLinksParentSelector)
	) {
		return anchor;
	}
}

function getTargetAnchor(target) {
	if (target.nodeName.toLowerCase() === "a") {
		return target;
	}
	return target.closest("a");
}

function isContainedBy(element, parentSelector) {
	return element.closest(parentSelector);
}

function isInPath(url, rootPathname) {
	return url && url.indexOf(rootPathname) !== -1;
}

function fetchPage(options, url) {
	const { targetElement, indicatorSelector } = options;

	showLoading({ options });

	return fetch(url)
		.then((response) => {
			if (response.ok) {
				return response.text();
			}
			return Promise.reject(response);
		})
		.then((html) => {
			const parser = new DOMParser();
			const freshPage = parser.parseFromString(html, "text/html");
			const freshMain = freshPage.querySelector("main");
			const freshTitle = freshPage.title;

			var scripts = getScripts(freshMain);

			Array.from(targetElement.childNodes)
				.filter((node) => {
					const isElement = node.nodeType == 1;
					return (
						!isElement ||
						(isElement && !node.matches(indicatorSelector))
					);
				})
				.forEach((node) => {
					node.remove();
				});
			Array.from(freshMain.childNodes).forEach((node) => {
				targetElement.append(node);
			});

			Array.from(scripts).forEach((script) => {
				loadScript(options, script.src);
			});

			document.title = freshTitle;

			exitLoading(options);

			return freshTitle;
		})
		.catch((error) => {

			// fallback to updating location directly
			window.location = url;
			log("error", error);
		});
}

function fetchPartial(options, url) {
	const { targetElement, containerId } = options;

	return fetch(url)
		.then((response) => {
			if (response.ok) {
				return response.text();
			}
			return Promise.reject(response);
		})
		.then((html) => {
			const parser = new DOMParser();
			const page = parser.parseFromString(html, "text/html");
			const partial = page.getElementById(containerId);

			Array.from(targetElement.childNodes).forEach((node)=>{
				node.remove();
			});
			Array.from(partial.childNodes).forEach((node)=>{
				targetElement.append(node);
			});

			return url;
		});
}

/*
	// close menu
	currentPath
	targetPath

	currentHash
	targetHash
	currentHashIsEmpty
	targetHashIsEmpty


	// new page
	currentPath != targetPath
		preventDefault
		pushHistory

	// same page
	currentPath == targetPath

		// scroll to h1
		targetHashIsEmpty
			preventDefault
			pushHistory

		// scroll
		currentHash != targetHash

		// rescroll
		currentHash == targetHash
*/
function getScripts(container) {
	const scriptsToLoad = container.getElementsByTagName("script");
	var scripts = [];
	Array.from(scriptsToLoad).forEach((script) => {
		if (script.src != "") {
			scripts.push({ src: script.src });
		}
	});

	return scripts;
}

// AddThis widget is injected outside the main element
// Visibility updated based on presence of social share block
function updateShareWidget() {
	const hasSocialShareBlock =
		document.querySelector(".block-social-share") !== null;
	const addThisWidgetSelector = ".at-custom-side-wrapper";
	const doHideAddThis = !hasSocialShareBlock;

	Array.from(document.querySelectorAll(addThisWidgetSelector)).forEach(
		(widget) => {
			widget.hidden = doHideAddThis;
		}
	);

	if (window.addthis) {
		window["addthis_share"].url = window.location.href;
		window["addthis_share"].title = window.document.title;
		window.addthis.toolbox(".addthis_toolbox");
	}
}

function loadScript(options, scriptSrc) {
	const { targetElement } = options;
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.src = scriptSrc;
	targetElement.append(script);
}

function delegatedClickHandler({ options, handlers }, event) {
	log("click handled:");

	const { targetElement } = options;

	const ajaxAnchorClicked = handlers.getLinkToFetch(event.target);
	if (ajaxAnchorClicked) {
		const href = ajaxAnchorClicked.href;
		const willUnhash = isSamePageWithoutHash(
			window.location.href,
			ajaxAnchorClicked.href
		);
		const doFetch = hasChangedPathOrQuery(
			window.location.href,
			ajaxAnchorClicked.href
		);

		if (willUnhash) {
			event.preventDefault();
			history.pushState({}, "", href);
			focusSection(targetElement, href);
		} else if (doFetch) {
			event.preventDefault();
			log("link hijacked", event, ajaxAnchorClicked, href);

			showLoading({ options, handlers });

			handlers.fetchHandler(href).then((freshTitle) => {
				// let stateObj = { foo: "bar" };
				// get title from returned page
				history.pushState({}, freshTitle, href);
				focusSection(targetElement, href);
				updateShareWidget();
			});
		} else {
			log("same page: default permitted");
		}
	}
}

function delegatedSubmitHandler({ state }, event) {

	if (event.target.matches("form[data-ajax-loader-partial]")) {

		event.preventDefault();
		log("submit caught", event);

		if (state.submitting) {
			return false;
		}

		state.submitting = true;

		const form = event.target;
		const containerId = form.dataset.ajaxLoaderPartialContainerId;
		const focusId = form.dataset.ajaxLoaderPartialFocusId;

		const action = new URL(form.action);
		const data = new FormData(form);
		// const initialSearch = new URLSearchParams(action.search);
		const search = new URLSearchParams([...data]);
		let url = `${action.origin}${action.pathname}?${search}${action.hash}`;

		let srcElement = event.submitter;
		let srcElementName =  srcElement.getAttribute("name");
		let srcElementValue = srcElement.value;

		if(action.origin === window.location.origin && action.pathname === window.location.pathname) {
			// non-destructively update window.location
			const existingSearchParams = new URLSearchParams(window.location.search);
			search.forEach((value, key) => {
				if(existingSearchParams.has(key)) {
					existingSearchParams.delete(key);
				}
				existingSearchParams.append(key, value);
			});

			if(srcElementName && srcElementValue){
				if(existingSearchParams.has(srcElementName)) {
					existingSearchParams.delete(srcElementName);
				}
				existingSearchParams.append(srcElementName, srcElementValue);
			}

			url = `${action.origin}${action.pathname}?${existingSearchParams}${action.hash}`;
		}

		// todo hash for error fallback

		// Display spinner button loading
		form.classList.add("is-submitting");

		fetchPartial({
			targetElement: document.getElementById(containerId),
			containerId
		}, url).then(() => {
			// let stateObj = { foo: "bar" };
			history.pushState({}, "", url);

			window.setTimeout(() => {
				const focusTarget = document.getElementById(focusId);
				if (focusTarget) {
					focusTarget.focus();
					state.submitting = false;
					form.classList.remove("is-submitting");
				}
			}, 0);
		})
		.catch((error) => {
			log("error", error);
			window.location = url;
		});


	}
}
function focusSection(ajaxElement, href) {
	const location = new URL(href);
	const hash = location.hash;

	window.setTimeout(() => {
		const hasHash = hash !== "";
		// Focus the h1 (or labelled section) to
		// cause screenreaders to read out the newly loaded content title
		const targetElement = document.querySelector(hasHash ? hash : "h1");
		targetElement.focus();

		scrollToAnchor(hasHash ? targetElement : ajaxElement);
	}, 0);
}

function scrollToAnchor(targetElement) {
	if (targetElement) {
		targetElement.scrollIntoView(true);
	} else {
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
	}
}

function historyHandler({ options, handlers, state }, event) {
	log(
		"location: " + document.location,
		document.location,
		"event.state: " + JSON.stringify(event.state),
		event.state,
		state
	);

	const { targetElement } = options;

	window.setTimeout(() => {
		const willUnhash = isSamePageWithoutHash(state.href, document.location);
		const doFetch = hasChangedPathOrQuery(state.href, document.location);
		if (willUnhash) {
			focusSection(targetElement, document.location.href);
		} else if (doFetch) {
			handlers.fetchHandler(document.location).then(() => {
				focusSection(targetElement, document.location.href);
			});
		}

		state.href = document.location.href;
	}, 0);
}

function hasChangedPathOrQuery(prevHref, newHref) {
	if (newHref === prevHref) {
		return false;
	}
	const prevLocation = new URL(prevHref);
	const newLocation = new URL(newHref);

	const searchChanged = newLocation.search !== prevLocation.search;
	const pathChanged = newLocation.pathname !== prevLocation.pathname;

	return searchChanged || pathChanged;
}

function isSamePageWithoutHash(prevHref, newHref) {
	const prevLocation = new URL(prevHref);
	const newLocation = new URL(newHref);
	if (prevLocation.pathname !== newLocation.pathname) {
		return false;
	}
	return newLocation.hash === "";
}

function showLoading({ options, handlers }) {
	const { targetElement, indicatorSelector } = options;
	// const { getIndicatorTemplate } = handlers;
	const indicator = targetElement.querySelector(indicatorSelector);

	if (!indicator) {
		const template = getTemplate(options.indicatorTemplateId);
		const createdIndicator = template.content;
		targetElement.prepend(createdIndicator);
	} else {
		indicator.hidden = false;
	}
}

function exitLoading(options) {
	const { targetElement, indicatorSelector } = options;
	const indicator = targetElement.querySelector(indicatorSelector);

	if (indicator) {
		indicator.classList.add("is-exiting");

		indicator.addEventListener("transitionend", hideLoading);
		indicator.classList.add("is-exiting");

		function hideLoading() {
			indicator.classList.remove("is-exiting");
			indicator.hidden = true;
		}
	}
}


export default init;



// WEBPACK FOOTER //
// ./project/client/src/core/components/ajax-loader/ajax-loader.js